import React from 'react';
import cx from 'classnames';

import Text from '../Text';

import styles from './LogicTab.module.scss';
import usePresenter from './LogicTab.presenter';
import getProps from './LogicTab.props';
import { LogicTabCombinedProps } from './types';

const LogicTab: React.FC<LogicTabCombinedProps> = (props) => {
  const {
    state,
    className,
    classes,
    disabled,
    buttonType,
    buttonForm,
    href,
    target,
    externalLink,
    onClick,
    text,
  } = usePresenter(props);

  const variantName = `${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`logicTab${variantName}`];

  let componentView;

  switch (variantName) {
    case 'Default':
    case 'Selected': {
      componentView = (
        <button
          disabled={disabled}
          type={buttonType}
          form={buttonForm}
          onClick={onClick}
          className={cx(currentStyle, className)}
        >
          <div className={cx(styles.textContent, classes?.textContent)}>
            <Text
              className={cx(styles.text, classes?.text)}
              {...internalProps.text}
              {...text}
            />
          </div>
        </button>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default LogicTab;
